import React from 'react';
import { connect } from 'dva';

import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer, modelUtils, } = framework_tool;
let { WizCard, WizSpin, WizForm, } = component_tool;

import {columns} from "./config";

class ThirdCorpUserSave extends WizContainer {
  componentName = 'ThirdCorpUserSave';

  constructor(props) {
    super(props);
    const {record, corpInfoId} = this.props;
    this.initialValue = {
      ...record,
      corpInfoId
    } || {}
    this.state = {
      loading: false,
    }
  }

  _render() {
    let formProps = {
      ref: 'form',
      columns: columns(this),
      onSubmit: this._onSubmit.bind(this),
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },
      style: { width: '100%' }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={this.state.loading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }

  propsAndStateOnChange = {
    save: this._save.bind(this),
  }

  _save(nextProps, nextState) {
    let o = nextProps.save
    nextState.loading = false;

    if (o['success']) {
      wizNotice.success(o['msg'])
      this.props.changeModal(false, true);
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _onSubmit(values) {
    this.setState({
      loading: true,
    })

    this.doAction({
      path: 'thirdCorpUser/save',
      payload: {
        key: 'save',
        apiParams: values
      }
    })
  }
}

const mapStateToProps = (state, ownProps) => {
  const { thirdCorpUser } = state;
  const save = modelUtils.getModelEntity(thirdCorpUser, 'save');
  return {
    save
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(ThirdCorpUserSave);
